import { Component, OnInit, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { LoginService } from './login.service';
import { FooterService } from './footer.service';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'app';
  public urlvalue: string;
  public url: any;
  private appURL: string = environment.apiUrl;
  private PortalURL: string = environment.portalUrl;
  private portalUrlWithSession: string = environment.portalUrlWithSession;
  public currentUser: any = null;
  public userType: number;

  url_class: any = false;
  hide: any;
  hides: any;
  private alertCheckInterval: any;  // To store the interval ID for checking schedules
  private alertIntervals: Map<number, any> = new Map();  // To store interval IDs for each event
  private lastAlertTimes: Map<number, number> = new Map(); // To track last alert times for each event
  isMembershipCardPage: boolean = false;
  mobileNavOpen: boolean = false;
  LoginUserType: any = '';
  module_access: any = '';
  userTypes = [
    { id: '0', name: 'Admin' },
    { id: '1', name: 'Manager' },
    { id: '2', name: 'Accountant' }
  ];

  constructor(public router: Router, private route: ActivatedRoute, private loginservice: LoginService,
    private cdRef: ChangeDetectorRef,
    private footerService: FooterService
  ) { }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Ensure it's parsed (if still a string from API)
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find module access object
    const mod = accessArray.find(m => m.module_id == module_id);
    // Return true if found (you can also check for specific rights)
    return !!mod;
  }

  ngOnInit() {
    this.initializeUser();
    this.setupRouterEvents();
    this.initializeIntervals();
    this.subscribeToCreditsUpdates();
    this.updateOrientationClass();
  }

  @HostListener('window:orientationchange')
  @HostListener('window:resize')
  updateOrientationClass() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const isLandscape = w > h;
    const isMobileOrTablet = Math.min(w, h) <= 820;
    // alert('width')
    // alert(w)
    // alert(h)
    if (isLandscape && isMobileOrTablet) {
      document.body.classList.add('landscape');
      document.body.classList.remove('portrait');
    } else {
      document.body.classList.remove('landscape');
      document.body.classList.add('portrait');
    }
    // Store actual px on body for debugging / future use
    document.body.setAttribute('data-vw', String(w));
    document.body.setAttribute('data-vh', String(h));
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  private initializeUser() {
    try {
      const userData = this.loginservice.getLocalSession('currentUser');
      if (userData) {
        this.currentUser = JSON.parse(userData);
        this.LoginUserType = this.currentUser.userType;
        if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
          try {
            this.module_access = JSON.parse(this.currentUser['module_access']);
          } catch (error) {
            this.module_access = '';
          }
        }
      } else {
        this.currentUser = null;
        this.LoginUserType = '';
      }
    } catch (error) {
      this.currentUser = null;
    }
  }

  private subscribeToCreditsUpdates() {
    this.loginservice.creditsUpdated$.subscribe(credits => {
      if (this.currentUser) {
        this.currentUser.credits = credits;
      }
    });
  }

  private setupRouterEvents() {
    this.updateUrlClass();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Re-read user from session on every navigation (picks up post-login state)
      this.initializeUser();
      const userData = this.loginservice.getLocalSession('currentUser');
      if (!userData && event.url !== '/' && !event.url.includes('changepassword')) {
        this.router.navigateByUrl('/');
        return;
      }
      this.updateUrlClass();
      // Trigger CD after state update to avoid ExpressionChangedAfterChecked
      this.cdRef.detectChanges();
    });
  }

  private initializeIntervals() {
    if (this.currentUser) {
      this.loginservice.deletePastCheckouts(this.currentUser.salon_id).subscribe(data => { },
        error => {
          alert('Network Error In App component deletePastCheckout API');
        });
    }

    this.urlvalue = '/';
    this.url = ['/', '/login', '/register', '/forgot-password', '/login?id=', '/resetpassword/'];

    setInterval(() => {
      this.checkAndRun();
    }, 7200000);
    if (this.currentUser) {
      this.alertCheckInterval = setInterval(() => {
        this.getScheduler();
      }, 1800000);
    }
  }

  private updateUrlClass() {
    const c_url = window.location.href;
    const isLogin = this.router.url === '/' || this.router.url.includes('login') || this.router.url.includes('changepassword') || this.router.url.includes('register');
    if (isLogin) {
      document.body.classList.add('login-active');
      this.footerService.hideFooter();
    } else {
      document.body.classList.remove('login-active');
      if (c_url.includes('billings')) {
        this.url_class = true;
        this.footerService.hideFooter();
      } else {
        this.url_class = false;
        this.footerService.showFooter();
      }
    }
  }

  // startSchedulerInterval() {
  //   const interval = setInterval(() => {
  //     this.getScheduler(interval);
  //   }, 1000);  // 10 seconds interval to check for schedules
  // }

  getScheduler() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');  // Month is 0-based, so add 1
    const day = today.getDate().toString().padStart(2, '0');  // Add leading zero to day if needed
    const hours = today.getHours().toString().padStart(2, '0');  // Add leading zero if needed
    const minutes = today.getMinutes().toString().padStart(2, '0');  // Add leading zero if needed
    const seconds = today.getSeconds().toString().padStart(2, '0');  // Add leading zero if needed
    const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    const currentDate = `${year}-${month}-${day}`;  // Format the current date
    this.loginservice.getScheduler(currentDateTime, currentDate, this.currentUser).subscribe((data: any) => {


      // Clear previous alert intervals
      this.alertIntervals.forEach((intervalId) => clearInterval(intervalId));
      this.alertIntervals.clear(); // Reset the intervals map
      this.lastAlertTimes.clear(); // Reset the last alert times map

      if (data['data'] && data['data'].length > 0) {
        data['data'].forEach(item => {
          if (item.scheduled_date) {
            const scheduledDateTime = new Date(item.scheduled_date.replace(' ', 'T'));  // Convert to Date object
            const currentTime = new Date();  // Get the current time

            const timeDifference = scheduledDateTime.getTime() - currentTime.getTime();  // Difference in milliseconds
            const tenMinutes = 10 * 60 * 1000;  // 10 minutes in milliseconds
            const thirtyMin = 1800000;  // 10 seconds in milliseconds

            // If more than 10 minutes before the scheduled time
            if (timeDifference > tenMinutes) {
              // Check if there's an existing alert interval for this event
              if (!this.alertIntervals.has(item.id)) {
                this.lastAlertTimes.set(item.id, currentTime.getTime()); // Initialize last alert time
                const alertInterval = setInterval(() => {
                  const lastAlertTime = this.lastAlertTimes.get(item.id);
                  const timeSinceLastAlert = (new Date().getTime() - lastAlertTime);

                  // If it's time for a new alert (every 10 seconds)
                  if (timeSinceLastAlert >= thirtyMin) {
                    alert(`Reminder: Scheduled event ID ${item.id} is approaching!`);

                    this.lastAlertTimes.set(item.id, new Date().getTime());  // Update the last alert time
                  }
                }, thirtyMin);  // Show alert every 10 seconds

                // Store the interval ID
                this.alertIntervals.set(item.id, alertInterval);
              }
            } else {
              // If within 10 minutes, stop the alert interval
              if (this.alertIntervals.has(item.id)) {
                clearInterval(this.alertIntervals.get(item.id));
                this.alertIntervals.delete(item.id); // Remove from intervals map
                this.lastAlertTimes.delete(item.id); // Remove from last alert times map

              }
            }
          }
        });
      }
    },
      error => {
        alert('Network Error In App component GetScheduler API');
      });
  }

  checkAndRun() {
    const today = new Date();
    const day = today.getDate();  // Get the current day of the month

    // Check if the current day is 1, 2, 15, or 17
    if ([1, 2, 15, 16].includes(day)) {
      // alert('Please Check Inventory Stock')
    }
  }

  // ngAfterContentInit() {
  //   this.cdRef.detectChanges();
  // }
  checkUserType() {


    this.userType = this.currentUser['userType'];
    if (this.userType == 0) {
      return true;
    } else {
      return false;
    }
  }

  toggleMobileNav() {
    this.mobileNavOpen = !this.mobileNavOpen;
  }

  logoutFromHeader() {
    localStorage.clear();
    if (this.loginservice.getLocalSession('currentSite') === null) {
      this.router.navigateByUrl('/');
    } else {
      window.location.href = this.PortalURL;
    }
  }

  toggleDropdown(event: Event) {
    if (window.innerWidth > 900) return;
    event.stopPropagation();
    const btn = (event.target as HTMLElement).closest('button');
    const li = btn ? btn.closest('.has-sub') : null;
    if (!li) return;
    const isOpen = li.classList.contains('open');
    Array.from(document.querySelectorAll('.has-sub.open'))
      .forEach((d: Element) => d.classList.remove('open'));
    if (!isOpen) li.classList.add('open');
  }

  closeMobileNav(event: Event) {
    const target = event.target as HTMLElement;
    // Close nav when a real link (not a dropbtn) is clicked
    if (target.tagName === 'A') {
      this.mobileNavOpen = false;
    }
  }

  mprint() {
    window.print();
  }


  loadMenu(url) {
    const isMobile = window.innerWidth <= 820;
    const isSelectport = this.router.url === '/Selectport';
    if (isSelectport && isMobile) {
      return true;
    }
    if (this.router.url === '/Reading-Club-Application' || this.router.url === '/Selectport' || this.router.url === '/' || this.router.url.includes('print-cusBill') || this.router.url.includes('membership-card') || this.router.url.includes('changepassword')) {
      if (this.router.url.includes('membership-card')) {
        this.isMembershipCardPage = true;
      }
      return false;
    } else {
      return true;
    }
  }

  loadDesktopMenu() {
    if (this.router.url === '/Reading-Club-Application' || this.router.url === '/Selectport' || this.router.url === '/' || this.router.url.includes('print-cusBill') || this.router.url.includes('membership-card') || this.router.url.includes('changepassword')) {
      return false;
    }
    return true;
  }

  public logoRedirect() {
    if (this.loginservice.getLocalSession('currentSite') === null) {
      this.router.navigateByUrl('/Selectport');
    } else {
      window.location.href = this.portalUrlWithSession;
    }
  };

  getUserTypeName(userType) {
    const type = this.userTypes.find(t => t.id === userType);
    return type ? type.name : 'Unknown';
  }

  getLogoPath(): string {
    if (this.currentUser && this.currentUser.logo) {
      // If salon has custom logo, use upload URL
      return `${environment.uploadUrl}uploads/salon_logos/${this.currentUser.logo}`;
    }
    // Default logo
    return 'assets/images/LogoMain.png';
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts